import "bootstrap/dist/css/bootstrap.css";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import "./Assets/css/style.css";

import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

import { useSelector } from 'react-redux';
import { useLazyGetGeneralQuery } from './Redux/Apis/General';
import AdminRouter from './Routers';
import { handleForegroundMessage, requestNotificationPermission } from './Utils/notification';

function App() {

  const [getGeneral] = useLazyGetGeneralQuery()
  const { general } = useSelector(state => state.generalSlice)

  if (process.env.REACT_APP_ENV !== "dev") {
    console.log = () => { }
    console.warn = () => { }
    console.error = () => { }
  }

  useEffect(() => {

    if (!general) {
      getGeneral()
    }

  }, [general])

  useEffect(() => {
    requestNotificationPermission();
    handleForegroundMessage();
  }, [])

  return (
    <>
      <ToastContainer pauseOnHover={false} />
      <AdminRouter />
    </>
  );
}

export default App;
